/** A soft wash of a palette colour, e.g. tint('warning-main', 12). */
export const tint = (token: string, percent: number) => `color-mix(in srgb, var(--mui-palette-${token}) ${percent}%, transparent)`;

/** Small grey label chips: list names, the draft id, "Research update". */
export const tagSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  px: 0.75,
  py: 0.25,
  borderRadius: 0.75,
  bgcolor: 'surface.sunken',
  color: 'text.secondary',
  fontSize: '0.6875rem',
  fontWeight: 500,
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
} as const;

export const enterSx = {
  '@keyframes approvalIn': { from: { opacity: 0, transform: 'translateY(4px)' }, to: { opacity: 1, transform: 'none' } },
  animation: 'approvalIn 220ms ease-out both',
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
} as const;

export const outlineButtonSx = { color: 'text.primary', borderColor: 'divider', bgcolor: 'background.paper' } as const;
